import { Check } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

const OFFERS = [
  {
    plan: "app",
    name: "Tempio Vivo App",
    price: "9,99",
    tagline: "Cresci in autonomia, ma non in isolamento.",
    features: [
      "Formazione cristiana",
      "Approfondimenti biblici",
      "Routine",
      "Deserto 40 giorni",
      "Allenamenti",
      "Ricette",
      "Diario",
      "Social interno",
      "Pubblicazione post e immagini",
      "Chat e gruppi tematici",
    ],
    cta: "Scelgo Tempio Vivo App",
    testid: "offer-app",
    highlighted: false,
  },
  {
    plan: "community",
    name: "Tempio Vivo Community Coaching",
    price: "49",
    tagline: "Cresci insieme, con un accompagnamento più diretto.",
    features: [
      "Tutto il piano App",
      "Incontri settimanali",
      "Gruppo WhatsApp privato",
      "Contatto WhatsApp con Elio e Chiara",
    ],
    cta: "Scelgo Community Coaching",
    testid: "offer-community",
    highlighted: true,
  },
];

export const OfferSummary = () => (
  <section id="offerte" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-6xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Riepilogo delle offerte"
        title={
          <>
            Un solo metodo.
            <br />
            Due modi di viverlo.
          </>
        }
        testid="offers-heading"
      />
      <div className="grid gap-8 md:grid-cols-2">
        {OFFERS.map((offer, i) => (
          <Reveal key={offer.plan} delay={0.1 * i}>
            <article
              data-testid={offer.testid}
              className={`relative flex h-full flex-col rounded-sm p-8 transition-all duration-300 sm:p-10 ${
                offer.highlighted
                  ? "border-2 border-[#C9A45C] bg-[#080808] shadow-[0_4px_40px_rgba(201,164,92,0.25)]"
                  : "border border-[#1B1B1B] bg-[#121212]"
              }`}
            >
              {offer.highlighted && (
                <span className="absolute -top-3.5 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-sm bg-[#C9A45C] px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-[#080808]">
                  Accompagnamento diretto
                </span>
              )}
              <h3 className="font-display text-2xl font-semibold text-white">
                {offer.name}
              </h3>
              <p className="mt-6">
                <span className="font-display text-5xl font-semibold text-[#C9A45C]">
                  {offer.price}&nbsp;€
                </span>
                <span className="ml-2 text-sm uppercase tracking-widest text-[#B8B8B8]">
                  /mese
                </span>
              </p>
              <p className="mt-4 text-sm font-semibold uppercase tracking-wider text-[#E8D5A3]">
                {offer.tagline}
              </p>
              <ul className="mt-6 flex-1 space-y-3 border-t border-[#1B1B1B] pt-6">
                {offer.features.map((f) => (
                  <li
                    key={f}
                    className="flex items-start gap-3 text-sm text-[#B8B8B8]"
                  >
                    <Check
                      className="mt-0.5 h-4 w-4 shrink-0 text-[#C9A45C]"
                      aria-hidden="true"
                    />
                    {f}
                  </li>
                ))}
              </ul>
              <div className="mt-8">
                <CtaButton
                  plan={offer.plan}
                  testid={`${offer.testid}-cta-button`}
                  variant={offer.highlighted ? "primary" : "secondary"}
                  className="w-full"
                >
                  {offer.cta}
                </CtaButton>
                <p className="mt-4 text-center text-[11px] uppercase tracking-widest text-[#8F7138]">
                  Pagamento sicuro tramite Stripe · Abbonamento mensile
                  ricorrente · Attivazione assistita.
                </p>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
